@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package mitra.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val android: DrawableResource by 
      lazy { init_android() }

  public val apple: DrawableResource by 
      lazy { init_apple() }

  public val compose_multiplatform: DrawableResource by 
      lazy { init_compose_multiplatform() }

  public val gemini_logo: DrawableResource by 
      lazy { init_gemini_logo() }

  public val gemini_logo_old: DrawableResource by 
      lazy { init_gemini_logo_old() }

  public val ic_paste: DrawableResource by 
      lazy { init_ic_paste() }

  public val java: DrawableResource by 
      lazy { init_java() }

  public val jetpack: DrawableResource by 
      lazy { init_jetpack() }

  public val logo: DrawableResource by 
      lazy { init_logo() }

  public val robot_1: DrawableResource by 
      lazy { init_robot_1() }

  public val robot_2: DrawableResource by 
      lazy { init_robot_2() }

  public val robot_3: DrawableResource by 
      lazy { init_robot_3() }

  public val robot_4: DrawableResource by 
      lazy { init_robot_4() }

  public val robot_5: DrawableResource by 
      lazy { init_robot_5() }

  public val robot_6: DrawableResource by 
      lazy { init_robot_6() }

  public val robot_7: DrawableResource by 
      lazy { init_robot_7() }

  public val robot_8: DrawableResource by 
      lazy { init_robot_8() }

  public val wasm: DrawableResource by 
      lazy { init_wasm() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("android", CommonMainDrawable0.android)
  map.put("apple", CommonMainDrawable0.apple)
  map.put("compose_multiplatform", CommonMainDrawable0.compose_multiplatform)
  map.put("gemini_logo", CommonMainDrawable0.gemini_logo)
  map.put("gemini_logo_old", CommonMainDrawable0.gemini_logo_old)
  map.put("ic_paste", CommonMainDrawable0.ic_paste)
  map.put("java", CommonMainDrawable0.java)
  map.put("jetpack", CommonMainDrawable0.jetpack)
  map.put("logo", CommonMainDrawable0.logo)
  map.put("robot_1", CommonMainDrawable0.robot_1)
  map.put("robot_2", CommonMainDrawable0.robot_2)
  map.put("robot_3", CommonMainDrawable0.robot_3)
  map.put("robot_4", CommonMainDrawable0.robot_4)
  map.put("robot_5", CommonMainDrawable0.robot_5)
  map.put("robot_6", CommonMainDrawable0.robot_6)
  map.put("robot_7", CommonMainDrawable0.robot_7)
  map.put("robot_8", CommonMainDrawable0.robot_8)
  map.put("wasm", CommonMainDrawable0.wasm)
}

internal val Res.drawable.android: DrawableResource
  get() = CommonMainDrawable0.android

private fun init_android(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:android",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/android.png", -1, -1),
    )
)

internal val Res.drawable.apple: DrawableResource
  get() = CommonMainDrawable0.apple

private fun init_apple(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:apple",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/apple.png", -1, -1),
    )
)

internal val Res.drawable.compose_multiplatform: DrawableResource
  get() = CommonMainDrawable0.compose_multiplatform

private fun init_compose_multiplatform(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:compose_multiplatform",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/compose-multiplatform.xml", -1, -1),
    )
)

internal val Res.drawable.gemini_logo: DrawableResource
  get() = CommonMainDrawable0.gemini_logo

private fun init_gemini_logo(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:gemini_logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/gemini_logo.svg", -1, -1),
    )
)

internal val Res.drawable.gemini_logo_old: DrawableResource
  get() = CommonMainDrawable0.gemini_logo_old

private fun init_gemini_logo_old(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:gemini_logo_old",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/gemini_logo_old.svg", -1, -1),
    )
)

internal val Res.drawable.ic_paste: DrawableResource
  get() = CommonMainDrawable0.ic_paste

private fun init_ic_paste(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_paste",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/ic_paste.xml", -1, -1),
    )
)

internal val Res.drawable.java: DrawableResource
  get() = CommonMainDrawable0.java

private fun init_java(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:java",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/java.png", -1, -1),
    )
)

internal val Res.drawable.jetpack: DrawableResource
  get() = CommonMainDrawable0.jetpack

private fun init_jetpack(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:jetpack",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/jetpack.png", -1, -1),
    )
)

internal val Res.drawable.logo: DrawableResource
  get() = CommonMainDrawable0.logo

private fun init_logo(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/logo.png", -1, -1),
    )
)

internal val Res.drawable.robot_1: DrawableResource
  get() = CommonMainDrawable0.robot_1

private fun init_robot_1(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:robot_1",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/robot_1.png", -1, -1),
    )
)

internal val Res.drawable.robot_2: DrawableResource
  get() = CommonMainDrawable0.robot_2

private fun init_robot_2(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:robot_2",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/robot_2.png", -1, -1),
    )
)

internal val Res.drawable.robot_3: DrawableResource
  get() = CommonMainDrawable0.robot_3

private fun init_robot_3(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:robot_3",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/robot_3.png", -1, -1),
    )
)

internal val Res.drawable.robot_4: DrawableResource
  get() = CommonMainDrawable0.robot_4

private fun init_robot_4(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:robot_4",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/robot_4.png", -1, -1),
    )
)

internal val Res.drawable.robot_5: DrawableResource
  get() = CommonMainDrawable0.robot_5

private fun init_robot_5(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:robot_5",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/robot_5.png", -1, -1),
    )
)

internal val Res.drawable.robot_6: DrawableResource
  get() = CommonMainDrawable0.robot_6

private fun init_robot_6(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:robot_6",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/robot_6.png", -1, -1),
    )
)

internal val Res.drawable.robot_7: DrawableResource
  get() = CommonMainDrawable0.robot_7

private fun init_robot_7(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:robot_7",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/robot_7.png", -1, -1),
    )
)

internal val Res.drawable.robot_8: DrawableResource
  get() = CommonMainDrawable0.robot_8

private fun init_robot_8(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:robot_8",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/robot_8.png", -1, -1),
    )
)

internal val Res.drawable.wasm: DrawableResource
  get() = CommonMainDrawable0.wasm

private fun init_wasm(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:wasm",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/mitra.composeapp.generated.resources/drawable/wasm.png", -1, -1),
    )
)
